import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-legal-modal-reconsent-cms-modal',
  templateUrl: './legal-modal-reconsent-cms-modal.component.html',
  styleUrls: ['./legal-modal-reconsent-cms-modal.component.scss']
})
export class LegalModalReconsentCmsModalComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  currentFacility: FacilityObject;
  private _facilityServiceOnChange: Subscription;
  temrsAndPrivacy:string;
  cloudBasePath: string;
  @Output() onsignout: EventEmitter<string> = new EventEmitter();  
  @Output() onClose:EventEmitter<any> = new EventEmitter();
  
  constructor (public commonUtil: CommonUtil, private _router: Router, private _facilityService: FacilityService) { }

  ngOnInit() {
    this.currentFacility = this._facilityService.selectedFacility();
    this.rootScopeData = this.commonUtil.rootScopeData;
    const terms = environment.currentHostPath + '/halo.html#/termsOfUse?locale='+this.rootScopeData.selectedLang+'&country='+this.currentFacility.summary.countryIsoCode+'&developerMode=false&selectedTncTab=tnc';
    const privacy = environment.currentHostPath + '/halo.html#/termsOfUse?locale='+this.rootScopeData.selectedLang+'&country='+this.currentFacility.summary.countryIsoCode+'&developerMode=false&selectedTncTab=privacy';
    this.temrsAndPrivacy = this.commonUtil.replaceValueAsHTMLOnTranslatedText('CUSTOM.LIBRARY.МОDAL.TERMS.UDATED',[terms]);
    const firstHashIndex = this.temrsAndPrivacy.indexOf('#');
    this.temrsAndPrivacy = this.temrsAndPrivacy.slice(0, firstHashIndex + 1) + this.temrsAndPrivacy.slice(firstHashIndex + 1, this.temrsAndPrivacy.length).replace('#', privacy);
    this.cloudBasePath = environment.cloudBasePath;
  }

  deleteAccount() {
    this._facilityServiceOnChange = this._facilityService.deleteAcount().subscribe( () => {
      this.onsignout.emit();
      this._router.navigate(['signout']);
    });
  }

  ngOnDestroy() {
    if (this._facilityServiceOnChange) {
      this._facilityServiceOnChange.unsubscribe();
    }
  }

  close(){
    this.onClose.emit();
  }
}
